<template>
  <router-view v-slot="{ Component }">
    <keep-alive exclude="WorkspaceItem">
      <component :is="Component" />
    </keep-alive>
  </router-view>
</template>

<script>
export default {
  components: {},
  props: {},
  emits: [],
  data() {
    return {}
  },
  watch: {},

  created() {
    this.$store.dispatch("data/getMyWorkspaceOrganizations")
  },

  methods: {}
}
</script>
